import { Head, Link } from "@inertiajs/react";
import { Heart, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import ParentLayout from "@/components/parents/ParentLayout";
import EmptyState from "@/components/EmptyState";

/**
 * /parents/dashboard for someone with no children activated yet. Once a
 * child is activated the controller goes straight to their page.
 */
export default function Dashboard({ school_name, claim_another_path, user_contexts }) {
  return (
    <ParentLayout school_name={school_name} siblings={[]} claim_another_path={claim_another_path} user_contexts={user_contexts} title="Activate your child">
      <Head title="Activate your child · PagePledge" />
      <EmptyState
        size="lg"
        icon={Heart}
        title="No children activated yet"
        description="Enter the activation code from your child's take-home sheet to follow their reading."
        action={
          <Button size="lg" asChild>
            <Link href={claim_another_path}>
              <Plus className="h-4 w-4" /> Activate your child
            </Link>
          </Button>
        }
      />
    </ParentLayout>
  );
}
